import * as React from "react";
import { DateiTypPlakette } from "../DateiTypSymbol";
import { statusText, type AblagePlatzhalter } from "./ablagePlatzhalter";
import "./ablagePlatzhalter.css";

type Props = {
    eintraege: readonly AblagePlatzhalter[];
    onErneut: (id: string) => void;
    kannErneut: (id: string) => boolean;
    onEntfernen: (id: string) => void;
};

/** Eine Zeile: Typ, Name, Stand — bei Fehler rot mit den zwei Auswegen. */
function Eintrag({ p, onErneut, kannErneut, onEntfernen }: { p: AblagePlatzhalter } & Omit<Props, "eintraege">) {
    return (
        <div className={`abl-ph abl-ph-${p.status}`} data-testid="ablage-platzhalter" data-status={p.status}>
            <DateiTypPlakette fileName={p.name} mimeType={p.mimeType} />
            <div className="abl-ph-text">
                <span className="abl-ph-name" title={p.name}>
                    {p.name}
                </span>
                <span className="abl-ph-stand" role={p.status === "fehler" ? "alert" : "status"}>
                    {statusText(p)}
                </span>
                {p.status !== "fehler" ? <span className="abl-ph-balken" aria-hidden /> : null}
            </div>
            {p.status === "fehler" ? (
                <span className="abl-ph-knoepfe">
                    {kannErneut(p.id) ? (
                        <button type="button" className="abl-ph-knopf" onClick={() => onErneut(p.id)}>
                            Erneut versuchen
                        </button>
                    ) : null}
                    <button type="button" className="abl-ph-knopf abl-ph-knopf-leise" onClick={() => onEntfernen(p.id)}>
                        Entfernen
                    </button>
                </span>
            ) : null}
        </div>
    );
}

/** Als Liste — z. B. in einer Vorgangs-/To-do-Karte. */
export function AblagePlatzhalterListe(props: Props): React.ReactElement | null {
    if (props.eintraege.length === 0) return null;
    return (
        <div className="abl-ph-liste" aria-live="polite">
            {props.eintraege.map((p) => (
                <Eintrag key={p.id} p={p} {...props} />
            ))}
        </div>
    );
}

/** Als Tabellenzeilen über den echten Zeilen — z. B. in den Kontakt-Dokumenten. */
export function AblagePlatzhalterZeilen({ spalten, ...props }: Props & { spalten: number }): React.ReactElement | null {
    if (props.eintraege.length === 0) return null;
    return (
        <>
            {props.eintraege.map((p) => (
                <tr key={p.id} className="abl-ph-zeile">
                    <td colSpan={spalten}>
                        <Eintrag p={p} {...props} />
                    </td>
                </tr>
            ))}
        </>
    );
}
